import { parseSessionAnalysisFields } from '../utils/parseAnalysisFields';

const formatSessionOwner = (userCreated) => {
  if (!userCreated) return 'Unknown user';
  const name = `${userCreated.first_name || ''} ${userCreated.last_name || ''}`.trim();
  return name || userCreated.email || 'Unknown user';
};

export const mapChatSessionToPanel = (session, currentUserId = null) => {
  const fields = parseSessionAnalysisFields(session);
  const sessionOwner = session?.user_created?.id;
  const isOwner = sessionOwner && currentUserId
    ? String(currentUserId) === String(sessionOwner)
    : false;

  const chatMetadata = {
    owner: formatSessionOwner(session?.user_created),
    source: session?.source_type || 'User Chat',
    user_created: session?.user_created,
    date_created: session?.date_created,
    linked_widget: session?.linked_widget,
    thread_id: session?.thread_id,
    assistant_id: session?.assistant_id,
    linkedlead: session?.linkedlead,
    overall_sentiment: session?.overall_sentiment,
    overall_sentiment_rationale: fields.rationale,
    overall_sentiment_topics: fields.topics,
    title: session?.title,
    intensity_score: fields.effort,
    business_risk: fields.priority,
    confidence: session?.confidence,
    messages_count: session?.messages_count,
    opening_valence: session?.opening_valence,
    closing_valence: session?.closing_valence,
    delta_valence: fields.delta,
    delta_open_to_close: fields.delta,
    closing_missing: session?.closing_missing,
    exit_intent: session?.exit_intent,
    resolution_status: fields.status,
    loop_detected: fields.loop,
    loop_count: session?.loop_count,
    core_min_valence: session?.core_min_valence,
    primary_intent: fields.intent,
    intent_fulfilled: session?.intent_fulfilled || null,
    effort_score: fields.effort,
    priority_band: fields.priority,
    no_progress_loop: fields.loop,
    recommended_action: session?.recommended_action || null,
    tags: fields.tags,
    judge_output: session?.judge_output || null,
    failed_recovery: fields.failedRecovery,
    unsupported_promise: fields.unsupportedPromise,
    turning_point: fields.turningPoint,
    turning_point_turn_id: session?.turning_point_turn_id ?? fields.turningPoint?.turn_id ?? null,
    turning_point_direction: session?.turning_point_direction ?? fields.turningPoint?.direction ?? null,
    turning_point_trigger: session?.turning_point_trigger ?? fields.turningPoint?.trigger ?? null
  };

  return { chatMetadata, isOwner };
};
